export default {
  sort: 2,
  path: '/edit/:id/:activeName',
  name: 'Edit',
  component: () => import('@/views/Edit'),
}



// WEBPACK FOOTER //
// ./src/router/modules/edit.js